import { useRef, useEffect } from 'react';
import Result from './Result';
import SearchResults from '../../../entities/SearchResults';
import Inventory from '../../../entities/Inventory';
import style from './ResultsBox.module.css';
import { translate } from '../../../helpers/translations';

interface ResultsBoxPropsInterface {
  results: SearchResults;
  hasBeenSubmitted: boolean;
  onInventorySelected: (inventory: Inventory) => void;
  onClose: () => void;
  loading: boolean;
}

export default function ResultsBox(props: ResultsBoxPropsInterface) {
  const {
    results,
    hasBeenSubmitted,
    onInventorySelected,
    onClose,
    loading,
  } = props;

  const modalEl = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleOutsideClick(event: MouseEvent) {
      const target = event.target as HTMLElement;

      if (modalEl.current && !modalEl.current.contains(target)) {
        onClose();
      }
    }

    if (hasBeenSubmitted) {
      document.addEventListener('click', handleOutsideClick, true);
      return () => {
        document.removeEventListener('click', handleOutsideClick, true);
      };
    }

    return undefined;
  }, [hasBeenSubmitted, onClose, modalEl]);

  if (!hasBeenSubmitted) {
    return null;
  }

  return (
    <div ref={modalEl} className={style.container}>
      {results.getSearchResults().length === 0 && !loading ? (
        <div className={style.noResults}>
          {translate('LYT_SECONDHAND_NO_RESULTS')}
        </div>
      ) : (
        <div className={style.results}>
          {results.getSearchResults().map((inventory: Inventory) => (
            <Result
              inventory={inventory}
              key={inventory.id}
              onInventorySelected={onInventorySelected}
            />
          ))}
        </div>
      )}
    </div>
  );
}
